import { useQuery } from '@tanstack/react-query';
import { api } from 'src/services';

type GetServiceRequestTypesResponse = {
  data: Array<{
    type_name: string;
    type_id: string;
  }>;
};

export const useGetServiceRequestTypes = () => {
  return useQuery({
    queryKey: ['serviceRequestTypes'],
    queryFn: () =>
      api
        .get<GetServiceRequestTypesResponse>('v3/service_request/types')
        .then(({ data }) => data.data),
  });
};
